import { render, staticRenderFns } from "./AdminAccounts.vue?vue&type=template&id=26004910&scoped=true"
import script from "./AdminAccounts.vue?vue&type=script&lang=ts"
export * from "./AdminAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26004910",
  null
  
)

export default component.exports